import { Slot } from "@radix-ui/react-slot";
import { cn } from "../../lib/utils";

type ButtonProps = {
  children: React.ReactNode;
  styleClass?: string;
  onClick?: () => void;
  disabled?: boolean;
  asChild?: boolean;
};
const Button = (props: ButtonProps) => {
  const { children, styleClass, onClick, disabled, asChild = false } = props;
  const Comp = asChild ? Slot : "button";
  return (
    <Comp
      className={cn(
        "bg-primary hover:bg-primary/80 cursor-pointer transition-all duration-150 text-white px-4 py-2 rounded-sm active:scale-95",
        styleClass,
        disabled && "opacity-50 cursor-not-allowed",
      )}
      onClick={onClick}
    >
      {children}
    </Comp>
  );
};

export default Button;
